export default __webpack_public_path__ + "static/media/nft.49aee5b0.png";